import React from 'react';
import { Typography, Card, Row, Col, Anchor } from 'antd';
import { useTranslation } from 'react-i18next';
import { SafetyOutlined } from '@ant-design/icons';
import SEO from '../../components/SEO';
import './PrivacyPage.css';

const { Title, Paragraph } = Typography;

const PrivacyPage: React.FC = () => {
  const { t } = useTranslation('landing');

  const renderList = (key: string) => {
    const items = t(key, { returnObjects: true }) as string[];
    return (
      <ul>
        {items.map((item: string, index: number) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    );
  };

  return (
    <>
      <SEO
        title="Политика конфиденциальности QATE | Защита данных пользователей"
        description="Политика конфиденциальности платформы QATE. Узнайте, как мы защищаем ваши данные, собираем и используем информацию в соответствии с законодательством."
        keywords="политика конфиденциальности QATE, защита данных, privacy policy, GDPR, персональные данные, безопасность информации"
        canonicalUrl="/privacy"
        ogTitle="Политика конфиденциальности QATE"
        ogDescription="Политика конфиденциальности платформы QATE. Узнайте, как мы защищаем ваши данные и обеспечиваем безопасность информации."
        noIndex={true}
        schema={{
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "Политика конфиденциальности",
          "description": "Документ о защите персональных данных пользователей платформы QATE",
          "isPartOf": {
            "@type": "WebSite",
            "name": "QATE",
            "url": "https://qate.ru"
          }
        }}
      />
      <div className="privacy-page">
        <div className="privacy-container">
          <Card className="privacy-card">
            <Title level={1}>{t('privacy.title')}</Title>
            <Paragraph>{t('privacy.lastUpdated')}</Paragraph>

            <Title level={2}>{t('privacy.introduction.title')}</Title>
            <Paragraph>{t('privacy.introduction.content')}</Paragraph>

            <Title level={2}>{t('privacy.information.title')}</Title>
            <Paragraph>{t('privacy.information.content')}</Paragraph>
            {renderList('privacy.information.items')}

            <Title level={2}>{t('privacy.usage.title')}</Title>
            <Paragraph>{t('privacy.usage.content')}</Paragraph>
            {renderList('privacy.usage.items')}

            <Title level={2}>{t('privacy.limitations.title')}</Title>
            <Paragraph>{t('privacy.limitations.content')}</Paragraph>

            <Title level={2}>{t('privacy.alpha.title')}</Title>
            <Paragraph>{t('privacy.alpha.content')}</Paragraph>
            {renderList('privacy.alpha.items')}

            <Title level={2}>{t('privacy.liability.title')}</Title>
            <Paragraph>{t('privacy.liability.content')}</Paragraph>
            {renderList('privacy.liability.items')}

            <Title level={2}>{t('privacy.security.title')}</Title>
            <Paragraph>{t('privacy.security.content')}</Paragraph>

            <Title level={2}>{t('privacy.rights.title')}</Title>
            <Paragraph>{t('privacy.rights.content')}</Paragraph>
            {renderList('privacy.rights.items')}

            <Title level={2}>{t('privacy.changes.title')}</Title>
            <Paragraph>{t('privacy.changes.content')}</Paragraph>

            <Title level={2}>{t('privacy.contact.title')}</Title>
            <Paragraph>{t('privacy.contact.content')}</Paragraph>
          </Card>
        </div>
      </div>
    </>
  );
};

export default PrivacyPage; 